// ScrollToTop.js - Utility component to automatically scroll to the top of the page on route changes.
// This functional component uses useEffect and useLocation to detect route transitions and reset scroll position,
// ensuring each page loads at the top for better UX in the SPA.
// No props needed; integrates seamlessly with React Router.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the pathname changes (i.e., on route navigation)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component doesn't render anything; it's purely functional
};

export default ScrollToTop;